import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ChangeSessionPageRoutingModule } from './change-session-routing.module';
import { ChangeSessionComponent } from './change-session/change-session.component';
import { CardTableModule } from 'libs/portal/src/modules/tools/card-table/card-table.module';
import { FiltersModule } from 'libs/portal/src/modules/tools/filters/filters.module';
import { MatButtonModule } from '@angular/material/button';
import { MaterialModule } from '@huge-monorepo/shared/modules';

@NgModule({
  imports: [CommonModule, FormsModule, ChangeSessionPageRoutingModule, CardTableModule, FiltersModule, MatButtonModule, MaterialModule],
  declarations: [ChangeSessionComponent],
})
export class ChangeSessionPageModule {}
